import { recordVmTrackingPageCode } from '../../util/vmTrackingHandler';
import { newGtmCustomEvent } from './gtmTrigger';
import { createMixPanelCustomEvent } from './mixPanelUtility';

export const createSuperEvent = (customEvent) => {
    try {
        newGtmCustomEvent(customEvent);
    } catch (e) {
        console.log(e);
    }
    try {
        createMixPanelCustomEvent(customEvent);
    } catch (e) {
        console.log(e);
    }
    try {
        recordVmTrackingPageCode(customEvent);
    } catch (e) {
        console.log(e);
    }
};
